export function isWebPSupported(callback: (result: boolean) => void) {
  const img = new Image();
  img.src =
    'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
  img.onload = function () {
    callback(img.height === 2);
  };

  img.onerror = function () {
    callback(false);
  };
}
